<template>
    <div class="card" v-if="rowsLoaded">
        <b-table
            striped
            hover
            responsive
            :items="rows"
            :fields="order.is_serial_number ? fields_with_serial : fields"
        >
            <template v-slot:cell(reference)="data">
                {{ data.item.reference }}
                <span
                    v-if="data.item.comment"
                    v-b-tooltip.hover
                    :title="data.item.comment"
                    class="ml-2"
                >
                    <font-awesome-icon icon="comment"></font-awesome-icon>
                </span>
            </template>
            <template v-slot:cell(completed)="data">
                {{ data.item.pass_count + data.item.repair_count }}
            </template>
            <template v-slot:cell(product_variant)="data">
                <span v-if="data.value.base_product">
                    {{ data.value.base_product.name }}
                </span>
                <em v-else class="text-info">
                    {{ $t("Looks like this SKU is not registered yet.") }}
                </em>
                <div
                    v-if="
                        data.item.product_variant &&
                        data.item.product_variant.base_product &&
                        data.item.product_variant.base_product.collection
                    "
                >
                    <small>
                        <span class="text-info">{{ $t("Collection") }}:</span>
                        {{
                            data.item.product_variant.base_product.collection
                                .name
                        }}
                    </small>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "OrdersViewOrder",
  props: {
    orderId: {
      type: String,
      default: ""
    },
    adminMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fields: [
        {
          key: "reference",
          sortable: true
        },
        {
          key: "product_variant",
          label: this.$t("Product Name"),
          sortable: true,
          class: "text-nowrap"
        },
        {
          key: "quantity",
          label: this.$t("Quantity"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "completed",
          label: this.$t("Completed"),
          sortable: true,
          class: "text-right"
        }
      ],
      fields_with_serial: [
        {
          key: "reference",
          sortable: true
        },
        {
          key: "serial_number",
          label: this.$t("Serial Number"),
          sortable: true,
          class: "text-center"
        },
        {
          key: "product_variant",
          label: this.$t("Product Name"),
          sortable: true,
          class: "text-nowrap"
        },
        {
          key: "quantity",
          label: this.$t("Quantity"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "completed",
          label: this.$t("Completed"),
          sortable: true,
          class: "text-right"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      order: state => state.purchaseOrders.order,
      loading: state => state.purchaseOrders.order.loading,
      rows: state => state.purchaseOrders.rows,
      rowsLoaded: state => state.purchaseOrders.rowsLoaded
    })
  },
  mounted() {
    if (!this.rowsLoaded) {
      this.getRows(this.order.id);
    }
  },
  methods: {
    ...mapActions({
      getRows: "purchaseOrders/getRows"
    })
  }
};
</script>

<style>
td.found-product {
  color: #659d74;
}

td.not-found-product {
  color: #a9a9a9;
}
</style>
